module.exports = __webpack_public_path__ + "f9ff905184496afa8380ba75566f68b8.png";